module.exports = __webpack_public_path__ + "a1c4b26f8b68380ef5cc3203601d992b.svg";